import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   data: import('./data').ReleaseDataReducer,
 *   ui: import('./ui').ReleasesUIReducer
 * }} ReleasesReducer
 */
export default combineReducers({
  data,
  ui,
});
